<template>
  <BContainer  class="p-0">
    <router-link v-if="$store.state.pos" :to="{name: 'OrderEnterPersonalDetails', params: {url: $store.state.pos?.url ?? '/'}, query: backQuery}" class="text-white mb-3 d-block back-btn">
      <IconArrowLeft color="#fff"/> {{ $t('back') }}</router-link>
    <div v-if="order && pos && !saving">
      <gtm-page-view v-if="order && order.event && order.event.gtm_id" :gtm_id="order.event.gtm_id"></gtm-page-view>

      <div class="content-block cart-container personal-details-header header-padding">
        <BRow>
          <BCol>
            <h1 class="mb-0">{{ $t('view_pos_cart_title') }}</h1>
            <label class="mb-0">{{ $t('pos_buy_extra_products') }}</label>
          </BCol>
          <BCol cols="3" class="d-flex align-items-center justify-content-end">
            <order-timer v-if="order" :order="order"></order-timer>
          </BCol>
        </BRow>
      </div>

      <div class="content-block cart-container personal-details-container">
        <product-list v-if="cart" :cross_sell="true"></product-list>
        <PosCartPlaceOrder @continue="continueOrder()"/>
      </div>
    </div>
    <BRow v-else>
      <BCol class="text-center">
        <h1>{{ $t('order_loading') }}</h1>
        <BSpinner style="width: 10em; height: 10em;"></BSpinner>
      </BCol>
    </BRow>
  </BContainer>
</template>

<script>
import api from '@/api'
import {mapState, mapGetters} from 'vuex'
import ProductList from '@/components/ProductList.vue'
import PosCartPlaceOrder from '@/components/PosCartPlaceOrder.vue';
import GtmPageView from '@/components/GtmPageView.vue';
import OrderTimer from '@/components/OrderTimer.vue';
import {BCol, BContainer, BRow, BSpinner} from "bootstrap-vue-next";
import IconArrowLeft from "../components/icons/IconArrowLeft.vue";

export default {
  components: {
    BSpinner,
    BCol,
    BRow,
    BContainer,
    OrderTimer,
    GtmPageView,
    PosCartPlaceOrder,
    ProductList,
    IconArrowLeft
  },
  data() {
    return {
      saving: false
    }
  },
  methods: {
    continueOrder() {
      this.saving = true
      let products = this.cart.products.filter(product => {
        return product.is_cross_sell
      }).map((product) => {
        return {product_id: product.id, amount: product.amount}
      })
      api.order().addCrossSell(this.order, products).then((order) => {
        this.$store.commit('setOrder', order)
        this.$router.push({
          name: 'OrderSelectPaymentMethod',
          params: this.$route.params
        })
      })
    },
  },
  computed: {
    backQuery() {
      if(this.campaign) {
        return {ft_campaign_name: this.campaign.slug, back: ''};
      }
      return {back: ''};
    },
    ...mapState(['order', 'pos', 'cart', 'campaign']),
    ...mapGetters(['posHasCrossSell'])
  },
  created() {
    api.order().getBySecret(this.$route.params.id, this.$route.params.secret).then((order) => {
      this.$store.commit('setOrder', order)

      if(this.posHasCrossSell === false) {
        if(this.campaign) {
          this.$router.push({name: 'OrderSelectPaymentMethod', params: this.$route.params, query:{ft_campaign_name: this.campaign.slug}})
        }
        else {
          this.$router.push({name: 'OrderSelectPaymentMethod', params: this.$route.params})
        }
      }
    })
  }
}
</script>

<style scoped>
.personal-details-header {
  border-radius: 10px 10px 0 0 !important;
  padding:42px 47px!important
}

.personal-details-header label {
  font-size: 16px !important;
  font-weight: bold !important;
}
.personal-details-container {
  border-radius:  0 0 10px 10px !important;
  margin-top: 1px !important;
}
@media only screen and (max-width: 992px) {
  .personal-details-container {
    padding: 17px !important;
  }
}
@media only screen and (max-width: 768px) {
  .personal-details-header label {
    font-size: 12px !important;
  }
  .personal-details-container > h2{
    font-size: 17px !important;
  }
  .personal-details-header {
    padding:17px!important
  }
}
</style>

<style>
.personal-details-container .product-row {
  padding: 0 !important;
}
</style>
